import DOMPurify from 'dompurify'

const RichTextContent = ({ content, className = '' }) => {
  if (!content) return null

  // If content looks like plain text (no HTML tags), render as-is
  const hasHtml = /<[a-z][\s\S]*>/i.test(content)
  if (!hasHtml) {
    return <p className={`text-sm text-gray-700 whitespace-pre-wrap ${className}`}>{content}</p>
  }

  const sanitized = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'a', 'img',
      'ul', 'ol', 'li', 'blockquote', 'pre', 'code', 'h1', 'h2', 'h3',
      'video', 'source',
      'table', 'thead', 'tbody', 'tr', 'td', 'th', 'hr',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel', 'class', 'controls', 'preload', 'type'],
  })

  return (
    <div
      className={`rich-text-content prose prose-sm max-w-none ${className}`}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  )
}

export default RichTextContent
